import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Modal, Icon } from 'semantic-ui-react';

import { EditRecipe } from 'Pages/managerecipe/subpages/editrecipe/EditRecipe';
import { submitRecipeForm } from 'Pages/managerecipe/state/editrecipe/actions';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import {
  isDirtySelector,
  isValidSelector,
  isSubmittingSelector,
  hasSubmitSucceededSelector,
} from 'Pages/managerecipe/state/editrecipe/selectors';

import 'Styles/pages/managemenu/recipeModal.less';

class RecipeModal extends Component {
  static propTypes = {
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
  };

  handleOnClose = () => {
    const { modalProps, isDirty, setYesNoDialogProps } = this.props;
    const { onClose } = modalProps;
    if (isDirty) {
      setYesNoDialogProps({
        showDialog: true,
        isSavePrompt: true,
        yesCallback: () => onClose(),
        noCallback: () => {},
      });
    } else {
      onClose();
    }
  };

  componentDidUpdate(prevProps) {
    const { submitSucceeded: submitSucceededPrev } = prevProps;
    const { submitSucceeded, modalProps, isValid } = this.props;
    const { onClose } = modalProps;

    if (submitSucceededPrev !== submitSucceeded && isValid) {
      onClose();
    }
  }

  render() {
    const { modalProps } = this.props;

    return (
      <Modal
        {...modalProps}
        onClose={this.handleOnClose}
        className="recipe-modal-container"
      >
        <Modal.Header>
          <Icon name="close" onClick={this.handleOnClose} />
        </Modal.Header>

        <Modal.Content scrolling>
          <EditRecipe openedInModal={true} />
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    isDirty: isDirtySelector(state),
    isValid: isValidSelector(state),
    submitting: isSubmittingSelector(state),
    submitSucceeded: hasSubmitSucceededSelector(state),
  };
};

const mapDispatchToProps = {
  submitRecipeForm,
  setYesNoDialogProps,
};

RecipeModal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecipeModal)
);

export { RecipeModal };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/RecipeModal.js